import axios from 'axios';
import store from '@/store';
import types from '@/store/types';
import router from '@/router';
import utils from '@/utils';



// CMS请求地址
const CFG_PATH = process.env.VUE_APP_CFG_PATH;
// API请求地址
const API_PATH = process.env.VUE_APP_API_PATH;
// WebSocket请求地址
const WS_PATH = process.env.VUE_APP_WS_PATH;
// OSS 地址
// const OSS_PATH = process.env.VUE_APP_OSS_PATH;

/*\
 * Loading 处理
\*/
let loading = null;
let loadingCount = 0;
// 显示Loading
const showLoading = () => {
  if (loadingCount === 0) {
    // loading = Loading.service({
    //   lock: true,
    //   text: '加载中……',
    //   background: 'rgba(0, 0, 0, 0.7)'
    // });
  }
  loadingCount += 1;
};
//  隐藏Loading
const hideLoading = () => {
  if (loadingCount <= 0) return false;
  loadingCount -= 1;
  if (loadingCount === 0) {
    loading?.close();
  }
}


const crmMaping = [{
  url:types.USER_EXIST,
  text:"尊敬的会员， Sisley 法国希思黎官方商城小程序将于2022年4月12日18点到2022年4月13日23点期间进行系统升级，升级期间平台部分会员注册/兑礼等业务将暂停使用。给您带来不便，敬请谅解！"
 }
]

/**
 * /crm暂停维护接口
 * url 请求全路径
*/
function isCrmPuaseList(url){
  for (let index = 0; index < crmMaping.length; index++) {
    const entry = crmMaping[index];
    if(url.includes(entry.url)){
      return entry;
    }
  }
  return false;
}

// 
axios.defaults.withCredentials = true;
// 请求拦截器
axios.interceptors.request.use(function (config) {
  //crm暂停
  if(localStorage.getItem("CRM_STATUS") ==1) {
   const url = config.url;
   const crmResult = isCrmPuaseList(url);
   if(crmResult){
    window.vm.$toast({ message: crmResult.text, iconCls: "failure" });
    return;
   }
  }

  showLoading();
  // config.headers['X-Request-With'] = 'XMLHttpRequest';
  // if (config.method == "post") {
  //   config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
  // }
  if (utils.hasItem('token')) {
    config.headers['token'] = utils.getItem('token');
    config.headers['refresh-token'] = utils.getItem("refresh_token");
  }
  // 请求来源： 1:小程序 2:mobile  3:pc
  config.headers['from'] = (utils.isMobile() || utils.isWXBrowser()) ? 2 : 3;
  // 
  return config;
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error);
});

// 响应拦截器
axios.interceptors.response.use(function (response) {
  if(response?.config?.url.includes(types.SITE_CONFIG)){
    localStorage.setItem("CRM_STATUS" , response?.data?.data?.CRM_STATUS?.key)
  }
  hideLoading();
  if (response?.data?.code == 2) {
    // TODO::
    let returnUrl = '';
    if (router?.history?.current?.query?.returnUrl) {
      returnUrl = router.history.current.query.returnUrl;
    } else {
      returnUrl = router?.history?.current?.fullPath;
    }
    store.dispatch(types.LOGOUT, () => {
      router.replace({
        path: '/',
        query: { returnUrl }
      }).then(() => {
        store.commit('toggleLogin', true);
      });
    });
    return Promise.resolve(response.data);
  } else {
    return Promise.resolve(response.data);
  }
}, function (error) {
  hideLoading();
  if (error ?.response ?.status == 404) {
    console.warn(`接口不存在: ${error?.config?.url}`);
  } else if (error ?.response ?.status == 500) {
    console.warn(`服务器错误: ${error?.config?.url}`);
  }
  return Promise.reject(error);
});

// 所有可用的组件
// eslint-disable-next-line no-unused-vars
const allTags = [];
// 需要继续请求的组件
// eslint-disable-next-line no-unused-vars
const allowXHRTags = ["multi_image_product"];

// 页面CMS模块请求方法
const ajax4Page = async (key, params, channel='os') => {
  let moduleCfg = await axios.get(`${CFG_PATH}${key}/${channel}.json?_t=${utils.dateFormat(new Date, 'YYYYMMddhh')}`, {
    ...params,
    withCredentials: false
  });
  return new Promise((resolve, reject) => {
    if (moduleCfg ?.nodes) {
      if (moduleCfg?.nodes.length == 1 && moduleCfg.nodes[0].tag == "navication_menu") {
        return resolve(moduleCfg.nodes[0]);
      }
      // // 获取所有组件名称
      // let plugins = moduleCfg.nodes.map(node => node.tag);
      // // 筛选出需要继续请求的组件
      // let ret = plugins.filter(item => allowXHRTags.indexOf(item) != -1);
      // if (ret ?.length) {
      //   console.warn("继续请求", ret);
      // }
      // 组件名转驼峰
      moduleCfg.nodes.forEach(node => {
        node.tag = node.tag.replace(/^(\w)/, (all, letter) => letter.toUpperCase()).replace(/_(\w)/g, (all, letter) => letter.toUpperCase());
        node.tag = node.tag.replace(/^xswiper$/i, 'XSwiper').replace(/^image$/i, 'XImage').replace(/^video$/i, 'XVideo');
      });
      resolve(moduleCfg);
    } else {
      reject(moduleCfg);
    }
  });
}

/*\
 * 接口列表
\*/
export default {
  // 
  API_PATH,
  // 密码登录
  [types.LOGIN_PASSWORD]: params => axios.post(`${API_PATH}${types.LOGIN_PASSWORD}`, params),
  // 手机号验证码登录
  [types.LOGIN_PHONE]: params => axios.post(`${API_PATH}${types.LOGIN_PHONE}`, params),
  // 生成图片验证码
  [types.GET_CAPTCHA]: params => axios.get(`${API_PATH}${types.GET_CAPTCHA}`, { params }),
  // 登录
  [types.USER_LOGIN]: params => axios.post(`${API_PATH}${types.USER_LOGIN}`, params),
  // 发送短信
  [types.SEND_MSG]: params => axios.post(`${API_PATH}${types.SEND_MSG}`, params),// 完善资料
  // 校验图片验证码
  [types.CHECK_CAPTCHA]: params => axios.post(`${API_PATH}${types.CHECK_CAPTCHA}`, params),
  // 手机号验证用户是否存在
  [types.USER_EXIST]: params => axios.get(`${API_PATH}${types.USER_EXIST}`, { params }),
  // 用户注册
  [types.USER_REGISTER]: params => axios.post(`${API_PATH}${types.USER_REGISTER}`, params),
  // 登录的第三方社交平台信息
  [types.SOCIAL_LIST]: params => axios.get(`${API_PATH}${types.SOCIAL_LIST}`, { params }),
  // 第三方平台通过code授权登录
  [types.LOGIN_SOCIAL]: params => axios.post(`${API_PATH}${types.LOGIN_SOCIAL}`, params),
  // 找回密码 / 重置密码
  [types.SET_PASSWORD]: params => axios.post(`${API_PATH}${types.SET_PASSWORD}`, params),
  // 用户退出
  [types.LOGOUT]: params => axios.post(`${API_PATH}${types.LOGOUT}`, params),
  // 添加足迹
  [types.FOOTPRINT_ADD]: params => axios.get(`${API_PATH}${types.FOOTPRINT_ADD}`, { params }),
  // 获取足迹列表
  [types.FOOTPRINT_LIST]: params => axios.get(`${API_PATH}${types.FOOTPRINT_LIST}`, { params }),
  // 获取收藏列表
  [types.FAV_LIST]: params => axios.get(`${API_PATH}${types.FAV_LIST}`, { params }),
  // 添加收藏
  [types.FAV_ADD]: params => axios.get(`${API_PATH}${types.FAV_ADD}`, { params }),
  // 删除收藏
  [types.FAV_DEL]: params => axios.get(`${API_PATH}${types.FAV_DEL}`, { params }),
  // 获取收藏商品ids
  [types.FAV_PIDS_LIST]: params => axios.get(`${API_PATH}${types.FAV_PIDS_LIST}`, { params }),
  // 添加地址
  [types.ADDRESS_ADD]: params => axios.post(`${API_PATH}${types.ADDRESS_ADD}`, params),
  // 删除地址
  [types.ADDRESS_DELETE]: params => axios.post(`${API_PATH}${types.ADDRESS_DELETE}`, params),
  // 更新地址
  [types.ADDRESS_UPDATE]: params => axios.post(`${API_PATH}${types.ADDRESS_UPDATE}`, params),
  // 设置默认地址
  [types.ADDRESS_SET_DEFAULT]: params => axios.get(`${API_PATH}${types.ADDRESS_SET_DEFAULT}`, { params }),
  // 展示地址
  [types.ADDRESS_LIST]: params => axios.get(`${API_PATH}${types.ADDRESS_LIST}`, { params }),
  // 获取用户信息
  [types.GET_ACCOUNT_INFO]: params => axios.get(`${API_PATH}${types.GET_ACCOUNT_INFO}`, { params }),
  // 领取优惠券
  [types.COUPON_ADD]: params => axios.get(`${API_PATH}${types.COUPON_ADD}`, { params }),
  // 我的优惠券
  [types.COUPON_LIST]: params => axios.get(`${API_PATH}${types.COUPON_LIST}`, { params }),
  // 
  [types.APPROACH_INFO]: params => axios.post(`${API_PATH}${types.APPROACH_INFO}`, params),
  // 
  [types.WX_WEB_AUTHORIZE]: params => axios.post(`${API_PATH}${types.WX_WEB_AUTHORIZE}`, params),
  // 积分商城列表
  [types.POINTS_MALL_LIST]: () => axios.get(`${API_PATH}${types.POINTS_MALL_LIST}`),
  // 兑换指定礼券
  [types.POINTS_MALL_EXCHANGE]: params => axios.get(`${API_PATH}${types.POINTS_MALL_EXCHANGE}`, { params }),
  // 我的兑换记录
  [types.POINTS_MALL_HISTORY]: params => axios.get(`${API_PATH}${types.POINTS_MALL_HISTORY}`, { params }),
  // 
  [types.SOCIAL_LOGIN]: params => axios.post(`${API_PATH}${types.SOCIAL_LOGIN}`, params),
  // 
  [types.NOTICE]: params => axios.post(`${API_PATH}${types.NOTICE}`, params),
  // 类目信息
  [types.CATEGORY_INFO]: params => axios.get(`${API_PATH}${types.CATEGORY_INFO}`, { params }),
  // 商品详情
  [types.GOODS_INFO]: params => axios.get(`${API_PATH}${types.GOODS_INFO}`, { params }),
  // 查询单个商品库存数量
  [types.GET_STOCK]: params => axios.get(`${API_PATH}${types.GET_STOCK}`, { params }),
  // 批量查询库存数量
  [types.BATCH_GET_STOCK]: params => axios.get(`${API_PATH}${types.BATCH_GET_STOCK}`, { params }),
  // 单个商品更新库存
  [types.UPDATE_STOCK]: params => axios.post(`${API_PATH}${types.UPDATE_STOCK}`, params),
  // 批量更新库存
  [types.BATCH_UPDATE_STOCK]: params => axios.post(`${API_PATH}${types.BATCH_UPDATE_STOCK}`, params),
  // 为您推荐
  [types.RECOMMEND_LIST]: params => axios.post(`${API_PATH}${types.RECOMMEND_LIST}`, params),
  // 店铺列表
  [types.STORE_LIST]: () => axios.get(`${API_PATH}${types.STORE_LIST}`),
  // 载入购物车
  [types.CART_GET]: params => axios.post(`${API_PATH}${types.CART_GET}`, params),
  // 加入购物车
  [types.CART_ADD]: params => axios.post(`${API_PATH}${types.CART_ADD}`, params),
  // 更新购物车条目
  [types.CART_UPDATE]: params => axios.post(`${API_PATH}${types.CART_UPDATE}`, params),
  // 更新购物车条目选中状态
  [types.CART_UPDATE_SELECTED]: params => axios.post(`${API_PATH}${types.CART_UPDATE_SELECTED}`, params),
  // 删除购物车中某个商品
  [types.CART_DELETE]: params => axios.post(`${API_PATH}${types.CART_DELETE}`, params),
  // 购物车预购商品库存检查
  [types.CART_STOCK_CHECK]: params => axios.post(`${API_PATH}${types.CART_STOCK_CHECK}`, params),
  // 订单确认
  [types.ORDER_CONFIRM]: params => axios.post(`${API_PATH}${types.ORDER_CONFIRM}`, params),
  // 游客订单确认
  [types.VISITOR_CONFIRM]: params => axios.post(`${API_PATH}${types.VISITOR_CONFIRM}`, params),
  // 创建订单
  [types.ORDER_CREATE]: params => axios.post(`${API_PATH}${types.ORDER_CREATE}`, params),
  // 游客创建订单
  [types.VISITOR_CREATE]: params => axios.post(`${API_PATH}${types.VISITOR_CREATE}`, params),
  // 订单列表
  [types.ORDER_LIST]: params => axios.get(`${API_PATH}${types.ORDER_LIST}`, { params }),
  // 订单详情
  [types.ORDER_INFO]: params => axios.get(`${API_PATH}${types.ORDER_INFO}`, { params }),
   //付邮试用创建订单
  [types.TRAIAL_ORDER_CREATE]: params => axios.post(`${API_PATH}${types.TRAIAL_ORDER_CREATE}`, params), 
  //付邮试用结算
  [types.TRIAL_ORDER_CONFIRM]: params => axios.post(`${API_PATH}${types.TRIAL_ORDER_CONFIRM}`, params),
  // 订单详情：支付状态#Track
  [types.ORDER_GA_QUERY]: params => axios.post(`${API_PATH}${types.ORDER_GA_QUERY}`, params),
  //付邮试用活动列表
  [types.TRIAL_LIST]: params => axios.post(`${API_PATH}${types.TRIAL_LIST}`, params),
  // 取消订单
  [types.ORDER_CANCEL]: params => axios.post(`${API_PATH}${types.ORDER_CANCEL}`, params),
  // 付款
  [types.ORDER_PAY]: params => axios.post(`${API_PATH}${types.ORDER_PAY}`, params),
  // 游客付款
  [types.VISITOR_ORDER_PAY]: params => axios.post(`${API_PATH}${types.VISITOR_ORDER_PAY}`, params),
  // 退款
  [types.ORDER_REFUND]: params => axios.post(`${API_PATH}${types.ORDER_REFUND}`, params),
  // 花呗分期手续费
  [types.ORDER_STAGES_INFO]: params => axios.post(`${API_PATH}${types.ORDER_STAGES_INFO}`, params),
  // 订单支付状态查询
  [types.HOTKEYWORDS]: params => axios.post(`${API_PATH}${types.HOTKEYWORDS}`, params),
  // 获取热门搜索
  [types.KEYWORDLIST]: params => axios.post(`${API_PATH}${types.KEYWORDLIST}`, params),
  // 搜索
  [types.HOT_SALE]: params => axios.get(`${API_PATH}${types.HOT_SALE}`, params),
  // 热销榜单
  [types.ADD_INVOICE]: params => axios.post(`${API_PATH}${types.ADD_INVOICE}`, params),
  // 添加开票信息
  [types.SEND_INVOICE_EMAIL]: params => axios.post(`${API_PATH}${types.SEND_INVOICE_EMAIL}`, params),
  // 发送发票到邮箱
  [types.INVOICE_QUERY]: params => axios.post(`${API_PATH}${types.INVOICE_QUERY}`, params),
  
  // 查询小程序端是否申请过开票
  [types.ORDER_PAY_STATUS_QUERY]: (sn, callback) => {
    if (!sn) return console.info("[warn] 缺少需要查询的订单编号"), false;
    let ws = new WebSocket(`${WS_PATH}`, ['VISITOR#EDC4sisleyrfv']);
    ws.onopen = function(evt) {
      console.info("WebSocket Connected", evt);
      ws.send(JSON.stringify({ "orderId": sn }));
    };
    ws.onmessage = function(evt) {
      callback(evt, ws);
    };
    return ws;
  },
  // 组件：商品列表
  [types.$CMP_CATEGORY_LIST]: params => axios.get(`${API_PATH}${types.$CMP_CATEGORY_LIST}`, { params }),
  // 组件：猜你喜欢 / 推荐商品列表
  [types.$CMP_RECOMMEND_LIST]: params => axios.get(`${API_PATH}${types.$CMP_RECOMMEND_LIST}`, { params }),
  // 页面：
  ajax4Page,
  // DashBoard# 商品详情 - 浏览上报
  [types.REPORT_BROWSER_PDP]: params => axios.post(`${API_PATH}${types.REPORT_BROWSER_PDP}`, params),
  // DashBoard# 商品分类 - 浏览上报
  [types.REPORT_BROWSER_PLP]: params => axios.post(`${API_PATH}${types.REPORT_BROWSER_PLP}`, params),
  // DashBoard# 商品详情 - 加购上报
  [types.REPORT_ADD_TO_CART]: params => axios.post(`${API_PATH}${types.REPORT_ADD_TO_CART}`, params),
  // DashBoard# Ga比对 - 付款成功上报
  [types.REPORT_PAY_SUCESS]: params => axios.post(`${API_PATH}${types.REPORT_PAY_SUCESS}`, params),
  // 主题颜色和购物车文案
  [types.SITE_CONFIG]: params => axios.get(`${API_PATH}${types.SITE_CONFIG}`, params),
  // 付邮试用详情
  [types.QUERY_POST_TRIAL]: params => axios.get(`${API_PATH}${types.QUERY_POST_TRIAL}`, { params }),
  // 付邮试用订单确认接口
  [types.TRIAL_ORDER_CONFIRM_NEW]: params => axios.post(`${API_PATH}${types.TRIAL_ORDER_CONFIRM_NEW}`, params),
  // 付邮试用订单创建接口
  [types.TRAIAL_ORDER_CREATE_NEW]: params => axios.post(`${API_PATH}${types.TRAIAL_ORDER_CREATE_NEW}`, params),
  //渠道上报接口
  [types.REPORT_CHANNEL]: params => axios.post(`${API_PATH}${types.REPORT_CHANNEL}`, params),
  //获取小程序跳转地址
  [types.MIN_PROGRAMN]: params => axios.post(`${API_PATH}${types.MIN_PROGRAMN}`, params),
  //领取优惠卷
  [types.GET_COUPON]: params => axios.post(`${API_PATH}${types.GET_COUPON}`, params),
  // 获取商品对应优惠券
  [types.PDP_COUPONS]: params => axios.post(`${API_PATH}${types.PDP_COUPONS}`, params),
  // 获取商品对应优惠券
  [types.PDP_USER_COUPONS]: params => axios.post(`${API_PATH}${types.PDP_USER_COUPONS}`, params),
  // 获取直播间信息
  [types.GET_LIVE_INFO]: params => axios.post(`${API_PATH}${types.GET_LIVE_INFO}`, params),
  // 查看可叠加优惠券信息
  [types.GET_REL_PRODUCTRULES]: params => axios.post(`${API_PATH}${types.GET_REL_PRODUCTRULES}`, params),
  // 查看当前商品赠品
  [types.GET_ADDITIONAL_GIFT]: params => axios.post(`${API_PATH}${types.GET_ADDITIONAL_GIFT}`, params),
  // 用户授权隐私协议
  [types.USER_AUTH]: params => axios.post(`${API_PATH}${types.USER_AUTH}`, params),
  //预览配置页面
  [types.GET_PREVIE_LANDING]: params => axios.post(`${API_PATH}${types.GET_PREVIE_LANDING}`, params),
  // 快递信息
  [types.GET_EXPRESS_INFO]: params => axios.post(`${API_PATH}${types.GET_EXPRESS_INFO}`, params),
  // 申请售后
  [types.CREATE_MANUAL_AFTER_SALES]: params => axios.post(`${API_PATH}${types.CREATE_MANUAL_AFTER_SALES}`, params),
  // 取消申请售后
  [types.CANCEL_MANUAL_AFTER_SALES]: params => axios.post(`${API_PATH}${types.CANCEL_MANUAL_AFTER_SALES}`, params),
	
};

// 
export const BMAP_KEY = "6vDI32X0kw8SihdIGfyAZ15z";